export const MODIFY_FINAL_COLUMN_PK = 'MODIFY_FINAL_COLUMN_PK';

export function modifyFinalColumnPK(finalColumnPK){
    return{
        type: MODIFY_FINAL_COLUMN_PK,
        mainState: {
            finalColumnPK: finalColumnPK
        }
    }
}